import { render } from "./AssociatedCoupons.vue?vue&type=template&id=1f21b10f"
import script from "./AssociatedCoupons.vue?vue&type=script&lang=js"
export * from "./AssociatedCoupons.vue?vue&type=script&lang=js"

import "./AssociatedCoupons.vue?vue&type=style&index=0&id=1f21b10f&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__